/**
 * @generated SignedSource<<c51f4353e39b2cde20d18af1fdeadc33>>
 * @relayHash 9ac17eed8ccf78d01d97aa65df347b63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ee7ee8fbc307b79c96c86825e8d17313c703e2d68aac3fb8040af5665a1b248b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectAndDevOpsToolRelationshipFilter = {
  hasPropertyEqualTo?: DevOpsContainerRelationshipEntityPropertyInput | null | undefined;
};
export type DevOpsContainerRelationshipEntityPropertyInput = {
  key: string;
  value: AGG$JSON;
};
export type main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery$variables = {
  devOpsToolRelationshipsFilter?: JiraProjectAndDevOpsToolRelationshipFilter | null | undefined;
  projectId: string;
  siteAri: string;
};
export type main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareProjectSettingsDevopsConnections_SideBar_groupRef" | "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewAppCounts_data" | "main_softwareProjectSettingsDevopsConnections_ToolchainOverview_data">;
};
export type main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery = {
  response: main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery$data;
  variables: main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "devOpsToolRelationshipsFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "projectId"
},
v9 = {
  "kind": "Literal",
  "name": "limit",
  "value": 100
},
v10 = [
  (v6/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "productKey"
},
v12 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "siteAri"
},
v13 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isDevOpsDataProvider"
},
v14 = {
  "kind": "ScalarField",
  "name": "providerType"
},
v15 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v16 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v17 = {
  "kind": "Variable",
  "name": "from",
  "variableName": "projectId"
},
v18 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "ConfluenceSpace"
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "ConfluencePage"
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "DevOpsFeatureFlag"
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "DevOpsOperationsComponentDetails"
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "DevOpsOperationsIncidentDetails"
},
v24 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "DevOpsOperationsPostIncidentReviewDetails"
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "DevOpsPullRequestDetails"
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "DevOpsRepository"
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "DevOpsSecurityVulnerabilityDetails"
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "JiraConfluenceRemoteIssueLink"
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "JiraCustomRemoteIssueLink"
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "JiraIssueRemoteIssueLink"
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "JiraWebRemoteIssueLink"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "main_softwareProjectSettingsDevopsConnections_SideBar_groupRef"
      },
      {
        "kind": "FragmentSpread",
        "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewAppCounts_data"
      },
      {
        "kind": "FragmentSpread",
        "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverview_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery",
    "selections": [
      {
        "concreteType": "DevOpsTools",
        "kind": "LinkedField",
        "name": "devOpsTools",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "DevOpsToolGroupConnection",
            "kind": "LinkedField",
            "name": "groups",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsToolGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "DevOpsToolGroup",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "groupName"
                      },
                      (v5/*: any*/),
                      {
                        "concreteType": "DevOpsToolCategoryConnection",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsToolCategoryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "DevOpsToolCategory",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ],
            "storageKey": "groups(first:20)"
          },
          {
            "args": (v3/*: any*/),
            "handle": "connection",
            "key": "List_groups",
            "kind": "LinkedHandle",
            "name": "groups"
          }
        ]
      },
      {
        "alias": "countDevOpsToolRelationships",
        "args": [
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "concreteType": "JiraProjectAndDevOpsToolRelationshipConnection",
        "kind": "LinkedField",
        "name": "devOpsToolRelationshipsForJiraProject",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectAndDevOpsToolRelationshipEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraProjectAndDevOpsToolRelationship",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                          "groupId"
                        ]
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "properties",
                    "storageKey": "properties(keys:[\"groupId\"])"
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v8/*: any*/)
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "devOpsToolRelationshipsFilter"
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "concreteType": "JiraProjectAndDevOpsToolRelationshipConnection",
        "kind": "LinkedField",
        "name": "devOpsToolRelationshipsForJiraProject",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectAndDevOpsToolRelationshipEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraProjectAndDevOpsToolRelationship",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "concreteType": "DevOpsTool",
                    "kind": "LinkedField",
                    "name": "devOpsTool",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "supportsContainers"
                      },
                      (v7/*: any*/),
                      {
                        "alias": "devInfoProvider",
                        "args": [
                          (v12/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                              "DEV_INFO"
                            ]
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "alias": "documentationProvider",
                        "args": [
                          (v12/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                              "DOCUMENTATION"
                            ]
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "alias": "securityProvider",
                        "args": [
                          (v12/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                              "SECURITY"
                            ]
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "alias": "operationsProvider",
                        "args": [
                          (v12/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                              "OPERATIONS"
                            ]
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v13/*: any*/),
                          (v6/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "DevOpsToolCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": (v10/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "integration",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDevOpsToolIntegration"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "appKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "appName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "marketplaceType"
                              },
                              {
                                "concreteType": "DevOpsToolAppLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "configure"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "getStarted"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "support"
                                  }
                                ]
                              }
                            ],
                            "type": "DevOpsToolIntegrationApp"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v11/*: any*/)
                            ],
                            "type": "DevOpsToolIntegrationProduct"
                          }
                        ]
                      },
                      {
                        "concreteType": "DevOpsToolGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "installed"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "containerRelationshipType"
                      },
                      (v16/*: any*/)
                    ]
                  },
                  (v16/*: any*/)
                ]
              }
            ]
          },
          (v16/*: any*/)
        ]
      },
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "concreteType": "AriGraph",
            "kind": "LinkedField",
            "name": "ariGraph",
            "plural": false,
            "selections": [
              {
                "alias": "documentationRelationships",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  (v17/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-documentation-entity"
                  }
                ],
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "confluenceEntity",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/)
                                ]
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "teamRelationships",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v17/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-opsgenie-team"
                  }
                ],
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "opsgenieTeam",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "OpsgenieTeam"
                                  },
                                  (v20/*: any*/),
                                  (v19/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/)
                                ]
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ee7ee8fbc307b79c96c86825e8d17313c703e2d68aac3fb8040af5665a1b248b",
    "metadata": {},
    "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "80f3858d17ef63e42f4dab5d764e8b59";

export default node;
